import styled from "@emotion/styled";
import type { AudioCaptureWaveformState } from "../audio-capture-actions.types";

interface AudioCaptureWaveformProps {
  waveform: AudioCaptureWaveformState;
}

export function AudioCaptureWaveform({ waveform }: AudioCaptureWaveformProps) {
  const { bars, maxBars } = waveform;

  return (
    <HistoryBarsContainer>
      {bars.map((height, index) => (
        <HistoryBar
          key={index}
          style={{
            height: `${height * 100}%`,
            transform: `translateX(${(index / maxBars) * 100}%) translateY(-50%)`,
            left: `${(index / maxBars) * 100}%`,
          }}
        />
      ))}
    </HistoryBarsContainer>
  );
}

const HistoryBarsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  min-width: 0px;
  width: 200px;
  max-width: 200px;
  margin-left: -140px;
  padding: 0 4px;
  position: relative;
  overflow: hidden;
  flex-grow: 2;
  height: 40px;
`;

const HistoryBar = styled.div`
  border-radius: 2px;
  width: 1.35%;
  margin: 0 0.025%;
  background-color: ${({ theme }) => theme.colors.icon.emphasis};
  transition: transform 0.2s ease-in-out;
  position: absolute;
  top: 50%;
  transform: translateX(0) translateY(-50%);
  will-change: transform;
`;
